// User-friendly error messages to prevent exposing internal database structure
const ERROR_MESSAGES: Record<string, string> = {
  'jwt expired': 'Je sessie is verlopen. Log opnieuw in.',
  'permission denied': 'Je hebt geen toegang tot deze actie.',
  'row-level security': 'Je hebt geen toegang tot deze gegevens.',
  'duplicate key': 'Dit item bestaat al.',
  'foreign key violation': 'Kan niet verwijderen: item is in gebruik.',
  'not found': 'Het gevraagde item is niet gevonden.',
  'invalid input': 'Ongeldige invoer. Controleer je gegevens.',
  'violates check constraint': 'Ongeldige waarde voor dit veld.',
  'network': 'Netwerkfout. Controleer je internetverbinding.',
  'fetch failed': 'Kan geen verbinding maken met de server.',
  'timeout': 'De server reageert niet. Probeer het later opnieuw.',
  'unauthorized': 'Je bent niet ingelogd of je sessie is verlopen.',
  'admin access required': 'Je hebt geen beheerdersrechten.',
};

/**
 * Converts technical error messages to user-friendly messages.
 * Logs the full error to console for debugging while showing safe messages to users.
 * 
 * @param error - The error object or message
 * @param context - Optional context for logging (e.g., "Product laden")
 * @returns A user-friendly error message in Dutch
 */
export const getUserFriendlyError = (error: unknown, context?: string): string => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  const lowerMessage = errorMessage.toLowerCase();
  
  // Log full error server-side for debugging (console only, not shown to user)
  console.error(`[${context || 'Error'}]:`, error);
  
  // Find matching user-friendly message
  for (const [key, userMsg] of Object.entries(ERROR_MESSAGES)) {
    if (lowerMessage.includes(key)) {
      return userMsg;
    }
  }
  
  // Generic fallback message
  return 'Er is een fout opgetreden. Probeer het later opnieuw.';
};
